import { isEmpty } from 'lodash'

const hasProfileNotifications = (state) => !isEmpty(state.auth.awaitingPaymentOrders)

export default hasProfileNotifications
